import React, { useEffect } from 'react';

function Copyright() {
  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div>
      <p>&copy; {new Date().getFullYear()} Stickers-Design. All rights reserved.</p>
      <p>Unauthorized use and/or duplication of this material without express and written permission from this site’s author and/or owner is strictly prohibited.</p>
    </div>
  );
}

export default Copyright;
